export enum AmlCheckTransactionStatus {
  Success = 'success',
  Failed = 'failed',
  Skipped = 'skipped',
}
